import { Component, OnInit, ChangeDetectorRef } from '@angular/core';
import { ApiService } from '../../../services/api.service';
import { Observable, Subscription } from 'rxjs';
import { Router } from '@angular/router';
import { SortablejsOptions } from 'ngx-sortablejs';
import { ToastrService } from 'ngx-toastr';

@Component({
  selector: 'app-step-two',
  templateUrl: './step-two.component.html',
  styleUrls: ['./step-two.component.scss']
})
export class StepTwoComponent implements OnInit {

  isLoading = false;
  pageTitle: string;
  checkAllPointsConfigured = false;

  allPoints: any;
  allPointsFiltered: any;
  selectedPointFiltered: number = 0;
  showDropdownInSaved: boolean = false;

  routeId = JSON.parse(localStorage.getItem('currentRouteId'));
  currentRoute: any;
  currentRoutePoints: any;
  showPoints: boolean = true;
  inputSelected:boolean = false;

  searchInSaved: string;
  searchInAddPoint: string;

  map: google.maps.Map;
  markers: any = [];
  placesService: google.maps.places.PlacesService;
  directionsService: google.maps.DirectionsService;
  directionsRenderer: google.maps.DirectionsRenderer;
  autocomplete: google.maps.places.Autocomplete;
  travelMode: string = 'WALKING';

  options: SortablejsOptions = {};

  constructor(private apiService: ApiService, private router: Router, private toastr: ToastrService, private changeDetectorRef: ChangeDetectorRef) {
    this.options = {
      onUpdate: (event: any) => {
        this.reorderPoints();
      }
    };

    setInterval(() => {
      this.changeDetectorRef.detectChanges();
    }, 1000);
  }

  ngOnInit(): void {
    this.currentRoute = JSON.parse(localStorage.getItem('userRoutes')).find(id => id.id === this.routeId);
    this.pageTitle = 'Édition du circuit ' + this.currentRoute.title;
    this.getAllPoints();
    this.getPoints(1);
    this.autocomplete = new google.maps.places.Autocomplete(
      document.getElementById("autocomplete") as HTMLInputElement
    );
    let autocomplete = this.autocomplete;
    autocomplete.setFields(["business_status", "formatted_address", "geometry", "icon", "name", "photos", "place_id", "plus_code"]);
    autocomplete.addListener("place_changed", () => {
      const place = autocomplete.getPlace();
      let title = place.name;
      let lat = place.geometry.location.lat();
      let lon = place.geometry.location.lng();
      let place_id = place.place_id;
      let description = place.formatted_address;
      this.addPoint(lat, lon, title, place_id, description);
      this.searchInAddPoint = '';
    });
  }

  getAllPoints() {
    this.apiService.getPoints('fr_FR').subscribe(
      data => {
        this.allPoints = data.data;
      },
      err => {
        console.log(err);
      }
    );
  }

  getPoints(initMap?) {
    this.apiService.getPoints('fr_FR', {route_id: this.routeId}).subscribe(
      data => {
        this.currentRoutePoints = JSON.parse(localStorage.getItem('currentRoutePoints'));
        this.checkIfAllPointsConfigured();
        if (this.currentRoutePoints.length) {
          this.showPoints = true;
        } else {
          this.showPoints = false;
        }
        if (initMap == 1) {
          this.initMap();
        } else if (this.currentRoutePoints.length > 1) {
          this.directionsRenderer.setMap(this.map);
          this.calculateAndDisplayRoute(this.currentRoutePoints);
        } else if (this.currentRoutePoints.length == 1) {
          this.directionsRenderer.setMap(null);
          this.removeMarkers();
          let position = new google.maps.LatLng(this.currentRoutePoints[0].lat, this.currentRoutePoints[0].lon);
          this.addMarker(position, this.currentRoutePoints[0].description, 1);
          this.showMarkers(this.map);
        } else if (!this.currentRoutePoints.length) {
          this.directionsRenderer.setMap(null);
          this.removeMarkers();
        }
      },
      err => {
        console.log(err);
      }
    );
  }

  addPoint(lat, lon, title, place_id?, description?, moreinfo?, medias?) {
    this.apiService.addPoint(this.routeId, 'fr_FR', lat, lon, title, {googleplace_id: place_id, description: description, moreinfo: moreinfo, medias: medias, etat: '2', order: (this.currentRoutePoints.length + 1)}).subscribe(
      data => {
        this.getPoints();
      },
      err => {
        console.log(err);
      }
    );
  }

  onRemovePoint(id) {
    let pointToRemove = this.currentRoutePoints.find(el => el.id == id);
    this.currentRoutePoints = this.currentRoutePoints.filter(function(el) { return el.id != id; });
    this.apiService.addPoint(this.routeId, 'fr_FR', pointToRemove.lat, pointToRemove.lon, pointToRemove.title, {point_id: pointToRemove.id, etat: '0'}).subscribe(
      data => {
        this.reorderPoints();
        this.toastr.success('Point supprimé');
      },
      err => {
        console.log(err);
      }
    );
  }

  reorderPoints() {
    const points = [];
    this.currentRoutePoints.forEach((element, index) => {
      if (element.order !== index + 1) {
        let point = {point_id: element.id, order: index + 1};
        points.push(point);
      }
    });
    if (points.length) {
      this.apiService.orderPoints('fr_FR', this.routeId, points).subscribe(
        data => {
          this.getPoints();
        },
        err => {
          console.log(err);
        }
      );
    } else {
      this.getPoints();
    }
  }

  onSearchInSaved(value: string, event?) {
    if (value) {
      this.showDropdownInSaved = true;
      this.allPointsFiltered = this.allPoints.filter(el => el.title.toLowerCase().startsWith(value.toLowerCase()));
      this.allPointsFiltered = this.allPointsFiltered.filter((point, index, self) =>
        index === self.findIndex((p) => (
          p.googleplace_id === point.googleplace_id
        ))
      );
      if (event) {
        if (event.key === 'ArrowDown') {
          if (this.selectedPointFiltered < this.allPointsFiltered.length && this.selectedPointFiltered < 5) {
            this.selectedPointFiltered = this.selectedPointFiltered + 1;
          }
          event.preventDefault();
        }
        if (event.key === 'ArrowUp') {
          if (this.selectedPointFiltered > 0) {
            this.selectedPointFiltered = this.selectedPointFiltered - 1;
          }
          event.preventDefault();
        }
        if (event.key === 'Enter') {
          this.newPointFromSaved(this.allPointsFiltered[this.selectedPointFiltered - 1]);
        }
      }
    } else {
      this.selectedPointFiltered = 0;
      this.showDropdownInSaved = false;
      this.allPointsFiltered = [];
    }
  }

  onFocus() {
    this.inputSelected = true;
  }

  onBlur() {
    setTimeout( () => this.inputSelected = false, 100 );
  }

  keepFocus(event) {
    if (event.key === 'ArrowDown') {
      event.preventDefault();
    }
    if (event.key === 'ArrowUp') {
      event.preventDefault();
    }
  }

  newPointFromSaved(point) {
    this.searchInSaved = '';
    this.selectedPointFiltered = 0;
    this.showDropdownInSaved = false;
    this.allPointsFiltered = [];
    let title = point.title;
    let lat = point.lat;
    let lon = point.lon;
    let place_id = point.googleplace_id;
    let description = point.description;
    this.addPoint(lat, lon, title, place_id, description);
    this.checkIfAllPointsConfigured();
  }

  initMap() {
    this.directionsService = new google.maps.DirectionsService();
    this.directionsRenderer = new google.maps.DirectionsRenderer({
      suppressMarkers : true
    });

    this.map = new google.maps.Map(document.getElementById("map"), {
      center: new google.maps.LatLng(48.866667, 2.333333),
      zoom: 15
    });
    this.directionsRenderer.setMap(this.map);
    if (this.currentRoutePoints.length > 1) {
      this.calculateAndDisplayRoute(this.currentRoutePoints);
    } else if (this.currentRoutePoints.length == 1) {
      let position = new google.maps.LatLng(this.currentRoutePoints[0].lat, this.currentRoutePoints[0].lon);
      this.addMarker(position, this.currentRoutePoints[0].description, 1);
      this.showMarkers(this.map);
    }
  }

  calculateAndDisplayRoute(routePoints) {
    let directionsService: google.maps.DirectionsService = this.directionsService;
    let directionsRenderer: google.maps.DirectionsRenderer = this.directionsRenderer;

    let origin;
    let destination;
    let waypoints = [];
    routePoints.forEach((element, index) => {
      if (index == 0) {
        origin = new google.maps.LatLng(element.lat, element.lon);
      } else if (index == routePoints.length - 1) {
        destination = new google.maps.LatLng(element.lat, element.lon);
      } else {
        waypoints.push({location: new google.maps.LatLng(element.lat, element.lon)})
      }
    });
    let request = {
      origin: origin,
      destination: destination,
      waypoints: waypoints,
      optimizeWaypoints: false,
      travelMode: google.maps.TravelMode[this.travelMode]
    };
    directionsService.route(
      request,
      (response, status) => {
        if (status == 'OK') {
          let markerCounter = 1;
          directionsRenderer.setDirections(response);
          let route = response.routes[0];
          this.removeMarkers();
          this.addMarker(route.legs[0].start_location, route.legs[0].start_address, markerCounter++);
          for (var i = 0; i < route.legs.length; i++) {
            this.addMarker(route.legs[i].end_location, route.legs[i].end_address, markerCounter++);
          }
          this.showMarkers(this.map);
        }
      }
    );
  }

  addMarker(position, adresse, i) {
    let marker = new google.maps.Marker({
      label: {text: String(i), color: "white"},
      position: position
    });
    let infowindow = new google.maps.InfoWindow({
      content: adresse
    });
    this.markers.push({marker: marker, infowindow: infowindow});
  }

  removeMarkers() {
    this.showMarkers(null);
    this.markers = [];
  }

  showMarkers(map) {
    for (let i = 0; i < this.markers.length; i++) {
      this.markers[i].marker.setMap(map);
      this.markers[i].marker.addListener("click", (element) => {
        this.displayInfoWindow(i);
      });
    }
  }

  displayInfoWindow(index) {
    this.markers.forEach((marker, index) => {
      marker.infowindow.close();
    });
    this.markers[index].infowindow.open(this.map, this.markers[index].marker);
  }

  changeTravelMode(mode) {
    this.travelMode = mode;
    this.calculateAndDisplayRoute(this.currentRoutePoints);
  }

  checkIfAllPointsConfigured() {
    this.checkAllPointsConfigured = true;
    this.currentRoutePoints.forEach((element, index) => {
      if (element.statut_edit == 0) {
        this.checkAllPointsConfigured = false;
      }
    });
  }

}
